import Swiper from 'swiper/bundle';

function initializeSwiper() {

  // swiper menu header
  const swiperMenuDesktop = new Swiper('.menu-desktop .swiper',  {
    slidesPerView: 3.2,
    spaceBetween: 20,
    keyboard: {
      enabled: true,
      onlyInViewport: false
    },
    mousewheel: {
      enabled: true,
      sensitivity: 4,
    },
    scrollbar: {
      el: '.menu-desktop .swiper-scrollbar',
      draggable: true,
      dragSize: '415px'
    }
  });


  // swiper header sitelock

  const swiperSitelock = new Swiper('.swiper-header-sitelock',  {
    slidesPerView: 3.2,
    spaceBetween: 20,
    keyboard: {
      enabled: true,
      onlyInViewport: false
    },
    mousewheel: {
      enabled: true,
      sensitivity: 4,
    },
  });

  // swiper page puma
  const swiperPuma = new Swiper('.swiper-puma', {
    slidesPerView: 1,
    autoHeight: true,
    calculateHeight: true,
    speed: 800,
    autoplay: {
      delay: 3000,
    },
  });

  let swiper = new Swiper(".swiper_slider", {
    slidesPerView: 2,
    spaceBetween: 30,
    freeMode: true,
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });


  var swiperCards = new Swiper(".swiper_slider_layout", {
    slidesPerView: 2,
    freeMode: true,
    mousewheel: true, 
    mousewheelControl: true,
    freeMode: true,
    followFinger: true,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  var swiperProduct = new Swiper(".swiper_carrousel_layout", {
    slidesPerView: 2,
    freeMode: true,    
    followFinger: true,
    loop: true,
    mousewheel: {
      forceToAxis: true,
      mousewheelControl: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const swiperArticle = new Swiper('.swiper-article-lookbook', {
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 15,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
});



  return{
    swiperSitelock,
    swiperPuma,
    swiperArticle,
    swiperMenuDesktop,
    swiperCards
  }
}

export default initializeSwiper;